/*
 * Church Tithe WP
 * https://www.churchtithewp.com
 *
 * Licensed under the GPL license.
 *
 * Author: Church Tithe WP
 * Version: 1.0
 * Date: April 18, 2018
 */

window.Grace_Tithe_HK_Form = class Grace_Tithe_HK_Form extends React.Component {

	constructor( props ){
		super(props);

		this.state = {
			editing_mode: false,
			editing_lightbox_active: false,
			all_initial_visual_states: {
				payment: {}
			},
			all_current_visual_states: this.props.all_current_visual_states, // This is an object containing the entire visual state for the Single Page App
			modal_visual_state: this.props.dynamic_settings.modal_visual_state,
			single_page_app_base_url: this.props.dynamic_settings.wordpress_permalink_only,
			dom_node: null,

			user_id: null,
			frontend_nonces: this.props.frontend_nonces
		};

		this.get_current_view_class = this.get_current_view_class.bind( this );
		this.set_all_current_visual_states = this.set_all_current_visual_states.bind( this );
		this.handle_visual_state_change_click_event = this.handle_visual_state_change_click_event.bind( this );

	}

	componentDidMount() {

		// Set the initial view state based on the initialization props
		this.setState( {
			editing_mode: this.props.editing_mode ? true : false,
			unique_settings: this.props.unique_settings,
			dynamic_settings: this.props.dynamic_settings,
			frontend_nonces: this.props.frontend_nonces,
			all_initial_visual_states: this.props.all_current_visual_states,
			all_current_visual_states: this.props.all_current_visual_states,
			modal_visual_state: this.props.dynamic_settings.modal_visual_state,
			initial_modal_visual_state: this.props.dynamic_settings.modal_visual_state
		}, function() {

			// If the URL in the browser's address bar doesn't match what the initial state is for some reason, adjust the browser's history so it's right
			//this.set_all_current_visual_states( this.state.all_initial_visual_states );

		} );

		// Prevent scroll jumps upon back button clicks
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}

		// Create an event listener to respond to back button clicks
		window.addEventListener('popstate', (e) => {
			this.on_web_history_change( e, this );
		});

	}

	componentDidUpdate( prevProps ) {
		this.maybe_refresh_parent_dom_node();

		if (
			prevProps.unique_settings !== this.props.unique_settings ||
			prevProps.dynamic_settings !== this.props.dynamic_settings ||
			prevProps.all_current_visual_states !== this.props.all_current_visual_states
		) {
			this.setState( {
				unique_settings: this.props.unique_settings,
				dynamic_settings: this.props.dynamic_settings,
				all_current_visual_states: this.props.all_current_visual_states,
				modal_visual_state: this.props.dynamic_settings.modal_visual_state,
			}, () => {
				this.set_all_current_visual_states( this.state.all_current_visual_states, this.state.modal_visual_state );
			} );
		}

		// If a modal is open but the view is still "button/text_link", force the payment form view.
		if (
			this.state.modal_visual_state &&
			Object.keys( this.state.modal_visual_state )[0]
		) {
			var current_view = Object.keys( this.state.all_current_visual_states || {} )[0];
			if ( 'button' === current_view || 'text_link' === current_view ) {
				this.set_all_current_visual_states( {
					payment: {
						form: {}
					}
				}, this.state.modal_visual_state );
			}
		}
	}

	maybe_refresh_parent_dom_node() {

		/*
		if ( this.state.dom_node !== ReactDOM.findDOMNode(this).parentNode ) {
			this.setState( {
				dom_node: ReactDOM.findDOMNode(this).parentNode
			} );
		}
		*/

	}

	on_web_history_change( e, this_component ) {

		var history_state = e.state;

		// If there's no state in the back button, we're in the initial state.
		if (history_state == null) {
			this_component.setState( {
				'all_current_visual_states': this_component.state.all_initial_visual_states,
				'modal_visual_state': this_component.state.initial_modal_visual_state
			} );
		}
		// If there is a state in the history, set the current state to that
		else {
			this_component.setState( {
				'all_current_visual_states': history_state.grace_tithe_hk_visual_state,
				'modal_visual_state': history_state.ctwpmodal_visual_state
			} );
		}

	}

	get_current_view_class( view_in_question ) {

		var currently_in_view_class_name = 'church-tithe-wp-current-view';
		var hidden_class_name = 'church-tithe-wp-hidden-view';
		var current_visual_state = Object.keys(this.state.all_current_visual_states)[0]; // This grabs the name of the the first key, which is the visual state of this component

		// If the current visual state matches the view we are getting the class for
		if( current_visual_state == view_in_question ) {

			return ' ' + currently_in_view_class_name;

		} else {

			return ' ' + hidden_class_name;

		}

	}

	get_featured_image_class() {

		const featuredImage = this.state.unique_settings.featured_image_url || this.state.unique_settings.default_logo_url || this.state.unique_settings.has_featured_image;
		if ( featuredImage ) {

			return ' church-tithe-wp-has-featured-image';

		} else {
			return '';
		}

	}

	render_featured_image() {

		const featuredImage = this.state.unique_settings.featured_image_url || this.state.unique_settings.default_logo_url || this.state.unique_settings.has_featured_image;
		if ( featuredImage ) {
			return (
				<div className="church-tithe-wp-logo">
					<div className="church-tithe-wp-header-logo-container">
						<div className="church-tithe-wp-header-logo-inner-bevel"></div>
						<div className="church-tithe-wp-header-logo-img" style={ {
							backgroundImage: 'url(' + featuredImage + ')',
							backgroundColor: '#ffffff'
						} }></div>
						<img
							className="church-tithe-wp-header-logo-img-fallback"
							src={ featuredImage }
							alt=""
							onError={ (event) => {
								const fallback = this.state.unique_settings.default_logo_url;
								if ( fallback && event.currentTarget.src !== fallback ) {
									event.currentTarget.src = fallback;
								}
							} }
							style={ {
								width: '70px',
								height: '70px',
								borderRadius: '100%',
								objectFit: 'cover',
								position: 'absolute',
								top: 0,
								left: 0,
								backgroundColor: '#ffffff',
								border: '3px solid #fff',
								boxShadow: '0 0 0 1px rgba(0,0,0,.18), 0 2px 2px 0 rgba(0,0,0,.08)',
								zIndex: 3,
								pointerEvents: 'none'
							} }
						/>
					</div>
				</div>
			)
		}
	}

	build_new_url_path( obj, new_url_path, depth ) {
		depth = depth + 1;
		var prefix = 1 == depth ? 'ctwp' : '&ctwp';
		for (var component_visual_state in obj) {
				new_url_path = this.build_new_url_path(obj[component_visual_state], new_url_path + prefix + depth + '=' + component_visual_state, depth );
		}
		return new_url_path;
	}

	handle_visual_state_change_click_event( new_state, new_modal_state, event ) {
		this.set_all_current_visual_states( new_state, new_modal_state );
	}

	set_all_current_visual_states( new_state = false, new_modal_state = false ) {

		var in_initial_state = false;

		return new Promise( (resolve, reject) => {

			// If the URL is an empty object, set it to the initial state
			if ( Object.entries(new_state).length === 0 && new_state.constructor === Object ) {
				new_state = this.state.all_initial_visual_states;
				in_initial_state = true;
			}

			// If no new state was passed, we're probably just updating the modal state.
			if ( ! new_state ) {
				new_state = this.state.all_current_visual_states;
			}

			// If no modal state was passed, we probably are just updating the main state.
			if ( ! new_modal_state ) {
				new_modal_state = this.state.modal_visual_state;
			}

			this.setState( {
				all_current_visual_states: new_state,
				modal_visual_state: new_modal_state
			}, () => {

				// New URL, make sure it handles URLs with and without a trailing slash
				if ( this.state.dynamic_settings.wordpress_permalink_only.includes("?") ) {
					var new_url_prefix = this.state.dynamic_settings.wordpress_permalink_only + '&';
				} else {
					var new_url_prefix = this.state.dynamic_settings.wordpress_permalink_only + '?';
				}

				var new_url = new_url_prefix + this.build_new_url_path( this.state.all_current_visual_states, '', 0 );

				// If there is a modal open, add it to the end of the URL
				if ( Object.keys(this.state.modal_visual_state)[0] ) {
					new_url = new_url + '&ctwpmodal=' + Object.keys(this.state.modal_visual_state)[0];
				}

				// Take a snapshot of the current visual state and add it to the web history
				if ( in_initial_state ) {
					history.pushState({
						grace_tithe_hk_visual_state: this.state.all_current_visual_states,
						ctwpmodal_visual_state: this.state.modal_visual_state
					}, new_state, this.state.dynamic_settings.wordpress_permalink_only);
				} else {
					history.pushState({
						grace_tithe_hk_visual_state: this.state.all_current_visual_states,
						ctwpmodal_visual_state: this.state.modal_visual_state
					}, new_state, new_url);
				}

				resolve( new_state );

			} );

		} );

	}

	render() {

		// Checks for HTTPS from the browser
		if ( window.location.protocol != "https:" ) {
			return(
				<div className={ 'church-tithe-wp-container' }>
					You must have an SSL certificate in order to accept payments on your website. Contact your webhost to have them install an SSL certificate on your website.
				</div>
			);
		}
		else if ( ! this.state.all_current_visual_states || ! this.state.unique_settings ) {
			return( <Grace_Tithe_HK_Spinner /> );
		}
		else if (
			! this.state.dynamic_settings.stripe_api_key ||
			! this.state.unique_settings.currency_code
		) {

			return (
				<div className={ 'church-tithe-wp-container' }>
					<div className={ 'church-tithe-wp-fancy-container church-tithe-wp-payment-view'}>
						<div className="church-tithe-wp-component-box">

							<header className="church-tithe-wp-header" role="banner">
								<h1 className="church-tithe-wp-header-title">Complete Set Up</h1>
								<h2 className={ 'church-tithe-wp-header-subtitle' }>You are almost ready to start accepting payments right here, using Church Tithe WP and Stripe. Click the link below to complete the set-up.</h2>
							</header>
							<div className="church-tithe-wp-payment-form-container">
								<div className={ 'church-tithe-wp-payment-box-view' }>
									<a href={ this.state.dynamic_settings.setup_link.replace(/&amp;/g, '&') }>Complete Church Tithe WP Setup</a>
								</div>
							</div>

						</div>
					</div>
				</div>
			);

		} else {

			var grace_tithe_hk_open_link = false;
			var modal_array = false;
			var grace_tithe_hk_form = false;

			if ( 'in_modal' === this.state.unique_settings.open_style ) {
				modal_array = {
					ctwp: {}
				}
			} else {
				modal_array = false;
			}

			if ( 'text_link' === this.state.unique_settings.mode ) {
				grace_tithe_hk_open_link = (
					<a className={ 'church-tithe-wp-a-tag' } onClick={ this.handle_visual_state_change_click_event.bind( null, {
						payment: {
							form: {}
						}
					}, modal_array ) }>{ this.state.unique_settings.strings.link_text }</a>
				);
			}

			if ( 'button' === this.state.unique_settings.mode ) {
				grace_tithe_hk_open_link = (
					<button className={ 'button church-tithe-wp-button' } onClick={ this.handle_visual_state_change_click_event.bind( null, {
						payment: {
							form: {}
						}
					}, modal_array ) }>{ this.state.unique_settings.strings.link_text }</button>
				);
			}

			grace_tithe_hk_form = (
				<div className={ 'church-tithe-wp-container church-tithe-wp-current-view-is-' + Object.keys(this.state.all_current_visual_states)[0] }>

					<div className={ 'church-tithe-wp-fancy-container church-tithe-wp-payment-view' + this.get_current_view_class( 'payment' ) + this.get_featured_image_class() }>

						{ this.render_featured_image() }

						<Grace_Tithe_HK_Payment_Box
							main_component={ this }
							show_close_button={
								'button' === Object.keys(this.state.all_initial_visual_states)[0] ||
								'text_link' === Object.keys(this.state.all_initial_visual_states)[0] ||
								'in_modal' === this.state.unique_settings.open_style
								? true : false
							}
						/>

					</div>

					<div className={ 'church-tithe-wp-fancy-container church-tithe-wp-manage-payments-view' + this.get_current_view_class( 'manage_payments' ) + this.get_featured_image_class() }>

						{ this.render_featured_image() }

						<Grace_Tithe_HK_Manage_Payments
							main_component={ this }
							show_close_button={
								'button' === Object.keys(this.state.all_initial_visual_states)[0] ||
								'text_link' === Object.keys(this.state.all_initial_visual_states)[0] ||
								'in_modal' === this.state.unique_settings.open_style
								? true : false
							}
						/>

					</div>

				</div>
			)

			if ( 'in_modal' === this.state.unique_settings.open_style ) {
				return (
					<React.Fragment>
						{
							// The modal used to open inside this component.
							// But now this component sits silently in the footer until triggered by an outside event.
							//grace_tithe_hk_open_link
						}
						<Grace_Tithe_HK_Modal
							main_component={ this }
							slug={ this.props.form_number }
							modal_contents={ grace_tithe_hk_form }
						/>
					</React.Fragment>
				)
			}

			if ( 'in_place' === this.state.unique_settings.open_style ) {

				if (
					'button' === Object.keys(this.state.all_current_visual_states)[0] ||
					'text_link' === Object.keys(this.state.all_current_visual_states)[0]
		 		) {
					return grace_tithe_hk_open_link;
				}

				return grace_tithe_hk_form;

			}

			// Handle the form showing by default
			return grace_tithe_hk_form;
		}
	}
}

window.grace_tithe_hk_refresh_a_tithing_element = function grace_tithe_hk_refresh_a_tithing_element( grace_tithe_hk_element ){

	// Get the form number for this form
	var form_number = grace_tithe_hk_element.getAttribute( 'church-tithe-wp-form-number' );

	// Get the unique settings to this shortcode
	var unique_settings_node = document.getElementById( 'church-tithe-wp-element-unique-vars-json-' + form_number );
	var dynamic_settings_node = document.getElementById( 'church-tithe-wp-element-dynamic-vars-json-' + form_number );
	var unique_shortcode_settings = null;
	var dynamic_shortcode_settings = null;

	if ( unique_settings_node ) {
		try {
			unique_shortcode_settings = JSON.parse( unique_settings_node.textContent );
		} catch ( error ) {
			unique_shortcode_settings = null;
		}
	}

	if ( dynamic_settings_node ) {
		try {
			dynamic_shortcode_settings = JSON.parse( dynamic_settings_node.textContent );
		} catch ( error ) {
			dynamic_shortcode_settings = null;
		}
	}

	if ( ! unique_shortcode_settings ) {
		var unique_data_attr = grace_tithe_hk_element.getAttribute( 'data-unique-vars' );
		if ( unique_data_attr ) {
			try {
				unique_shortcode_settings = JSON.parse( unique_data_attr );
			} catch ( error ) {
				unique_shortcode_settings = null;
			}
		}
	}

	if ( ! dynamic_shortcode_settings ) {
		var dynamic_data_attr = grace_tithe_hk_element.getAttribute( 'data-dynamic-vars' );
		if ( dynamic_data_attr ) {
			try {
				dynamic_shortcode_settings = JSON.parse( dynamic_data_attr );
			} catch ( error ) {
				dynamic_shortcode_settings = null;
			}
		}
	}

	if ( ! unique_shortcode_settings || ! dynamic_shortcode_settings ) {
		return;
	}

	var grace_tithe_hk_get_ctwp_query_params = function() {
		var params = {};
		if ( window.URLSearchParams ) {
			var search = new URLSearchParams( window.location.search );
			['ctwp1', 'ctwp2', 'ctwp3', 'ctwpmodal'].forEach( function( key ) {
				if ( search.has( key ) ) {
					params[ key ] = search.get( key );
				}
			} );
			return params;
		}

		if ( window.location.search && window.location.search.length > 1 ) {
			window.location.search
				.substring( 1 )
				.split( '&' )
				.forEach( function( pair ) {
					var parts = pair.split( '=' );
					var key = decodeURIComponent( parts[0] || '' );
					var value = decodeURIComponent( parts[1] || '' );
					if ( key ) {
						params[ key ] = value;
					}
				} );
		}

		return params;
	};

	var grace_tithe_hk_apply_visual_state_from_url = function( dynamic_settings ) {
		var url_params = grace_tithe_hk_get_ctwp_query_params();
		if ( ! url_params.ctwp1 ) {
			return;
		}

		var url_visual_state = {};
		var top_state = url_params.ctwp1;

		// If a modal is requested but the URL is stuck on button/text_link, force the payment form view.
		if (
			url_params.ctwpmodal &&
			( 'button' === top_state || 'text_link' === top_state )
		) {
			top_state = 'payment';
		}

		url_visual_state[ top_state ] = {};

		if ( url_params.ctwp2 ) {
			url_visual_state[ top_state ][ url_params.ctwp2 ] = {};
			if ( url_params.ctwp3 ) {
				url_visual_state[ top_state ][ url_params.ctwp2 ][ url_params.ctwp3 ] = {};
			}
		}

		// If we forced payment view but no ctwp2 was provided, default to the form view.
		if ( 'payment' === top_state && ! url_params.ctwp2 ) {
			url_visual_state.payment.form = {};
		}

		dynamic_settings.all_default_visual_states = url_visual_state;
	};

	var grace_tithe_hk_apply_modal_from_url = function( dynamic_settings ) {
		var url_params = grace_tithe_hk_get_ctwp_query_params();
		if ( url_params.ctwpmodal ) {
			dynamic_settings.modal_visual_state = {
				[ url_params.ctwpmodal ]: {}
			};
		}
	};

	var grace_tithe_hk_get_form_numbers_on_page = function() {
		return Array.from( document.querySelectorAll( '.church-tithe-wp-element' ) )
			.map( function( el ) {
				return el.getAttribute( 'church-tithe-wp-form-number' );
			} )
			.filter( function( value ) {
				return value;
			} );
	};

	var grace_tithe_hk_normalize_modal_visual_state = function( dynamic_settings ) {
		if ( ! dynamic_settings || ! dynamic_settings.modal_visual_state ) {
			return;
		}

		var modal_keys = Object.keys( dynamic_settings.modal_visual_state );
		if ( ! modal_keys.length ) {
			return;
		}

		var form_numbers = grace_tithe_hk_get_form_numbers_on_page();
		if ( ! form_numbers.length ) {
			return;
		}

		var desired_modal_key = String( modal_keys[0] );

		if (
			'auto' === desired_modal_key ||
			'first' === desired_modal_key ||
			-1 === form_numbers.indexOf( desired_modal_key )
		) {
			dynamic_settings.modal_visual_state = {
				[form_numbers[0]]: {}
			};
		}
	};

	grace_tithe_hk_apply_visual_state_from_url( dynamic_shortcode_settings );
	grace_tithe_hk_apply_modal_from_url( dynamic_shortcode_settings );
	grace_tithe_hk_normalize_modal_visual_state( dynamic_shortcode_settings );

	var top_level_visual_state = 'payment';

	var all_default_visual_states = {}

	//If a default visual state is in the URL, it wins
	if ( 'inherit' !== dynamic_shortcode_settings.all_default_visual_states ) {

		// Use the default visual state from the URL
		all_default_visual_states = dynamic_shortcode_settings.all_default_visual_states;

	} else {

		// If the shortcode has a mode attached, use it
		if ( 'form' == unique_shortcode_settings.mode ) {
			all_default_visual_states = {
				payment: {},
			};
		} else {
			all_default_visual_states = {
				[unique_shortcode_settings.mode]: {},
			};
		}

	}

	ReactDOM.render( <Grace_Tithe_HK_Form
		key={ 'grace_tithe_hk_button_element_' + form_number }
		id={ 'grace_tithe_hk_button_element_' + form_number }
		form_number={ form_number }
		all_current_visual_states={ all_default_visual_states }
		frontend_nonces={ grace_tithe_hk_js_vars.frontend_nonces }
		unique_settings={ unique_shortcode_settings }
		dynamic_settings={ dynamic_shortcode_settings }
	/>, grace_tithe_hk_element );

}

window.grace_tithe_hk_refresh_all_tithing_elements = function grace_tithe_hk_refresh_all_tithing_elements(){

	var grace_tithe_hk_element_exists = document.querySelector( '.church-tithe-wp-element' );

	if ( grace_tithe_hk_element_exists ) {

		var grace_tithe_hk_elements = document.querySelectorAll( '.church-tithe-wp-element' );

		var counter = 0;

		// Loop through each Church Tithe WP element on the page
		grace_tithe_hk_elements.forEach(function( grace_tithe_hk_element ) {

			// Get the form number for this form
			var form_number = grace_tithe_hk_element.getAttribute( 'church-tithe-wp-form-number' );

			grace_tithe_hk_refresh_a_tithing_element( grace_tithe_hk_element );
		});
	}
}
grace_tithe_hk_refresh_all_tithing_elements();

window.grace_tithe_hk_set_modal_to_open = function grace_tithe_hk_set_modal_to_open( form_number ) {

	var grace_tithe_hk_element_exists = document.querySelector( '.church-tithe-wp-element' );

	// Set all tithe jar forms on the page to have their modals closed, then we'll open this one.
	if ( grace_tithe_hk_element_exists ) {

		var grace_tithe_hk_elements = document.querySelectorAll( '.church-tithe-wp-element' );

		var counter = 0;

		// Loop through each Church Tithe WP element on the page
		grace_tithe_hk_elements.forEach(function( grace_tithe_hk_element ) {

			// Get the form number for this form
			var form_number = grace_tithe_hk_element.getAttribute( 'church-tithe-wp-form-number' );

			// Get the unique settings to this shortcode
			var dynamic_shortcode_settings_container = document.getElementById( 'church-tithe-wp-element-dynamic-vars-json-' + form_number );
			var dynamic_shortcode_settings = null;

			if ( dynamic_shortcode_settings_container ) {
				try {
					dynamic_shortcode_settings = JSON.parse( dynamic_shortcode_settings_container.textContent );
				} catch ( error ) {
					dynamic_shortcode_settings = null;
				}
			}

			if ( ! dynamic_shortcode_settings ) {
				var dynamic_data_attr = grace_tithe_hk_element.getAttribute( 'data-dynamic-vars' );
				if ( dynamic_data_attr ) {
					try {
						dynamic_shortcode_settings = JSON.parse( dynamic_data_attr );
					} catch ( error ) {
						dynamic_shortcode_settings = null;
					}
				}
			}

			if ( ! dynamic_shortcode_settings ) {
				return;
			}

			// Set the status of the modal to be closed
			dynamic_shortcode_settings.modal_visual_state = {};

			// Rewrite the JSON to the DOM
			if ( dynamic_shortcode_settings_container ) {
				dynamic_shortcode_settings_container.textContent = JSON.stringify( dynamic_shortcode_settings );
			} else {
				grace_tithe_hk_element.setAttribute( 'data-dynamic-vars', JSON.stringify( dynamic_shortcode_settings ) );
			}
		} );

		// Refresh all React payment form components on the page
		grace_tithe_hk_refresh_all_tithing_elements();

	}

	var element_holding_settings = document.getElementById( 'church-tithe-wp-element-dynamic-vars-json-' + form_number );
	var grace_tithe_hk_element = document.getElementById( 'church-tithe-wp-element-' + form_number );

	// Get the unique settings to this shortcode
	var dynamic_shortcode_settings = null;

	if ( element_holding_settings ) {
		try {
			dynamic_shortcode_settings = JSON.parse( element_holding_settings.textContent );
		} catch ( error ) {
			dynamic_shortcode_settings = null;
		}
	}

	if ( ! dynamic_shortcode_settings && grace_tithe_hk_element ) {
		var dynamic_data_attr = grace_tithe_hk_element.getAttribute( 'data-dynamic-vars' );
		if ( dynamic_data_attr ) {
			try {
				dynamic_shortcode_settings = JSON.parse( dynamic_data_attr );
			} catch ( error ) {
				dynamic_shortcode_settings = null;
			}
		}
	}

	if ( ! dynamic_shortcode_settings ) {
		return;
	}

	// Set the state of the form to be "payment/form"
	dynamic_shortcode_settings.all_default_visual_states = {
		payment: {
			form: {}
		}
	};

	// Set the status of the modal to be open
	dynamic_shortcode_settings.modal_visual_state = {
		[form_number]: {}
	};

	// Rewrite the JSON to the DOM
	if ( element_holding_settings ) {
		element_holding_settings.textContent = JSON.stringify( dynamic_shortcode_settings );
	} else if ( grace_tithe_hk_element ) {
		grace_tithe_hk_element.setAttribute( 'data-dynamic-vars', JSON.stringify( dynamic_shortcode_settings ) );
	}

	// Refresh all React payment form components on the page
	grace_tithe_hk_refresh_a_tithing_element( grace_tithe_hk_element );
}
